// Single source for the Regional Representatives page (desktop table and
// mobile cards both read from here)

export interface ICompany {
  name?: string;
  phone?: string;
  email?: string;
  address?: string;
}

export interface TableType {
  key: number;
  country: string;
  company?: string | ICompany;
  representative?: string;
  flag: string;
}

export const representatives: TableType[] = [
  {
    key: 1,
    country: "Azerbaijan",
    flag: "/images/azerbaijan.png",
    company: {
      phone: "+994 10 212 05 35",
      email: "aleskerli13@gmail.com",
    },
    representative: "FIKRET ALESKERLI",
  },
  {
    key: 2,
    country: "Georgia",
    flag: "/images/georgia.png",
    company: {
      name: "",
      phone: "",
      email: "v.lashkaradze@gmail.com",
      address: "",
    },
    representative: "VAKHTANG LASHKARADZE",
  },
  {
    key: 3,
    country: "Kazakhstan",
    flag: "/images/kazakhstan.png",
    company: {
      name: "",
      phone: "",
      email: "",
      address: "",
    },
    representative: "",
  },
  {
    key: 4,
    country: "Kyrgyzstan",
    flag: "/images/kyrgyzstan.png",
    company: {
      name: "",
      phone: "+996 556 218 128",
      email: "azamatsolomon@gmail.com",
      address: "",
    },
    representative: "AZAMAT SULAIMANOV ",
  },
  {
    key: 5,
    country: "Tajikistan",
    flag: "/images/tajikistan.png",
    company: {},
    representative: "",
  },
  {
    key: 6,
    country: "Turkey",
    flag: "/images/turkey.png",
    company: {
      name: "",
      phone: "+90 532 204 54 06",
      email: "usedele@sdlygm.com.tr",
      address: "",
    },
    representative: "UMUT SHEDELE",
  },
  {
    key: 7,
    country: "Turmenistan",
    flag: "/images/turkmenistan.png",
    company: {
      name: "",
      phone: "",
      email: "",
      address: "",
    },
    representative: "",
  },

  {
    key: 8,
    country: "Moldova",
    flag: "/images/moldova.png",
    company: {
      name: "",
      phone: "",
      email: "neovama@gmail.com",
      address: "",
    },
    representative: "VADIM MUNTEAN",
  },
  {
    key: 9,
    country: "Ukraine",
    flag: "/images/ukraine.png",
    company: {
      name: "",
      email: "",
      address: "",
      phone: "+380 96 970 99 99",
    },
    representative: "ANDREY BOGOMOLOV",
  },
  {
    key: 10,
    country: "Uzbekistan",
    flag: "/images/uzbekistan.png",
    company: {
      name: "",
      phone: "",
      address: "",
      email: "nurjavovgayrat@gmail.com",
    },
    representative: "GAYRAT NURJAVOV",
  },
];
